import { useIntl } from 'react-intl';
import { SimpleGrid } from '@chakra-ui/react';
import ComboboxFormikField from 'components/forms/ComboboxFormikField';

const SpotPriceTab = ({ options }) => {
    const intl = useIntl();

    return (
        <SimpleGrid spacingX={6} spacingY={5} columns={3}>
            <ComboboxFormikField
                id="refSpotPriceId"
                name="refSpotPriceId"
                label={intl.formatMessage({ id: 'basis_reference_spot_price' })}
                options={options.spotPrices}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
            <ComboboxFormikField
                id="delSpotPriceId"
                name="delSpotPriceId"
                label={intl.formatMessage({ id: 'basis_delivery_spot_price' })}
                options={options.spotPrices}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
        </SimpleGrid>
    );
};

export default SpotPriceTab;
